import { useMemo, useState } from "react";
import { CONTACT_CARD_EDIT_MODES, CONTACT_TYPES } from "@miplatform/constants";
import { ClientFilter, debounce } from "@miplatform/utils";
import {
  ContactsTabView,
  FilteredDataVerticalTabsLayout,
  MiContactCard,
} from "@mibuildweb/components";
import { Box } from "@mui/material";
import { AddEditContactRelationDrawer } from "../AddEditContactRelationDrawer/AddEditContactRelationDrawer";

export function CommunityContactsTab({
  community: { contacts, referenceId = null } = {},
  reload = () => {},
}) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [filteredData, setFilteredData] = useState(contacts);
  const [selectedContact, setSelectedContact] = useState(null);
  const [search, setSearch] = useState("");
  const referenceIds = useMemo(
    () => ({
      [CONTACT_TYPES.COMMUNITIES]: referenceId,
    }),
    [referenceId]
  );

  const clientFilterManager = useMemo(() => {
    const filter = new ClientFilter(
      contacts,
      ["firstName lastName", "title"],
      setFilteredData
    );
    filter.handleSort("isPrimary", "desc");
    filter.handleSearch(search);

    return filter;
  }, [contacts]);

  const handleSearch = (value) => {
    setSearch(value);
    debounce(clientFilterManager.handleSearch(value));
  };

  const renderContactCard = (contact) => (
    <Box key={`${contact.id}${contact.level}${contact.label}`}>
      <MiContactCard
        isPrimaryDisabled
        enableDeleteRelationship
        contact={contact}
        accountId={contact.accountId}
        referenceIds={referenceIds}
        onRefresh={reload}
        editMode={CONTACT_CARD_EDIT_MODES.CONTACT}
        defaultContactLevel={CONTACT_TYPES.COMMUNITIES}
      />
    </Box>
  );

  return (
    <>
      <FilteredDataVerticalTabsLayout
        allOptionLabel="All Contacts"
        showAllOption
        data={filteredData}
        filteredKeyExtractor={(item) => item.accountName}
        viewComponent={ContactsTabView}
        extraLayoutProps={{
          contacts,
          openDrawer: () => setIsDrawerOpen(true),
          handleSearch,
          search,
          renderContactCard,
        }}
        useLegacyStyles
      />
      <AddEditContactRelationDrawer
        selectedContact={selectedContact}
        defaultContactLevel={CONTACT_TYPES.COMMUNITIES}
        referenceIds={referenceIds}
        open={isDrawerOpen}
        onClose={() => {
          setIsDrawerOpen(false);
          setSelectedContact(null);
        }}
        onRefresh={reload}
      />
    </>
  );
}
